import { motion } from "framer-motion";
import { ArrowDown, Sparkles, Code, Cloud } from "lucide-react";

const HERO_BG = "https://images.pexels.com/photos/2092075/pexels-photo-2092075.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const HeroSection = ({ onApplyClick }) => {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={HERO_BG}
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="hero-overlay absolute inset-0" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 pt-32 pb-20 w-full">
        <div className="max-w-4xl">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="mb-8"
          >
            <span className="inline-flex items-center gap-2 text-xs font-mono tracking-[0.25em] uppercase text-neutral-400 border border-white/10 px-4 py-2">
              <span className="w-2 h-2 bg-white rounded-full animate-pulse" />
              Edición Limitada
            </span>
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            data-testid="hero-title"
            className="text-4xl sm:text-5xl lg:text-7xl font-black tracking-tighter text-white leading-[0.95] mb-8"
            style={{ fontFamily: "'Syne', sans-serif" }}
          >
            Desarrollo de software a medida...{" "}
            <span className="relative">
              completamente
              <span className="absolute -bottom-1 left-0 w-full h-[3px] bg-white" />
            </span>{" "}
            ¡GRATIS!
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            data-testid="hero-subtitle"
            className="text-base sm:text-lg text-neutral-400 leading-relaxed max-w-2xl mb-8"
          >
            Por tiempo limitado, en Zulunity diseñamos y construimos para tu empresa
            una solución de software a medida sin costo de desarrollo: sitio web,
            aplicación web o herramienta interna, según tus necesidades.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
            className="flex flex-col sm:flex-row gap-4 sm:gap-6 mb-12"
          >
            <div className="flex items-center gap-3 text-sm text-neutral-300">
              <Code className="w-4 h-4 text-white flex-shrink-0" />
              <span>Software hecho a la medida, NO PLANTILLAS</span>
            </div>
            <div className="flex items-center gap-3 text-sm text-neutral-300">
              <Sparkles className="w-4 h-4 text-white flex-shrink-0" />
              <span>Ideal para startups y empresas</span>
            </div>
            <div className="flex items-center gap-3 text-sm text-neutral-300">
              <Cloud className="w-4 h-4 text-white flex-shrink-0" />
              <span>Equipo experto en cloud y datos</span>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.4 }}
            className="flex flex-col sm:flex-row items-start gap-4"
          >
            <button
              data-testid="hero-cta-btn"
              onClick={onApplyClick}
              className="group bg-white text-black font-bold text-sm tracking-[0.15em] uppercase px-10 py-5 hover:bg-neutral-200 transition-all active:scale-95"
            >
              Quiero mi desarrollo gratis
              <span className="inline-block ml-2 group-hover:translate-x-1 transition-transform">&rarr;</span>
            </button>
            <p className="text-xs text-neutral-500 max-w-xs leading-relaxed pt-2">
              Completa el formulario y revisaremos si tu proyecto aplica para esta campaña.
            </p>
          </motion.div>
        </div>
      </div>

      {/* Scroll indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-neutral-500"
      >
        <ArrowDown className="w-5 h-5 animate-bounce" />
      </motion.div>
    </section>
  );
};

export default HeroSection;
